<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps } from 'vue';
import UtilFile from '@/utils/UtilFile';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    value: {
        type: Array
    }
});

/*==================================================================*/
/*================== MÉTODOS =======================================*/
/*==================================================================*/

const abreAnexo = (anexo = null) => {

    UtilFile.openFileInNewWindow(anexo);

};

</script>

<template>

    <div v-if="props.value.length" class="c-anexos">

        <a
            v-for="(anexo, index) in props.value"
            :key="anexo?.name || index"
            class="c-anexos__anexo"
            @click="abreAnexo(anexo)"
        >
            • Anexo {{ index + 1 }}
        </a>

    </div>

</template>

<style scoped>

.c-anexos {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.c-anexos__anexo {
    font-size: 0.875rem;
    color: #32434d;
    text-decoration: underline;
    cursor: pointer;
}

</style>